import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Coins } from "lucide-react";
import api, { apiErr } from "@/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [cf, setCf] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) return toast.error("Password must be at least 6 characters");
    if (pw !== cf) return toast.error("Passwords do not match");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password reset! Please log in.");
      navigate("/login");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-md card-surface rounded-3xl p-8 glow-emerald">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <Coins className="h-7 w-7 text-emerald-400" />
          <span className="text-xl font-extrabold">ERAN <span className="text-emerald-400">USD</span></span>
        </Link>
        <h1 className="text-2xl font-bold mb-1 text-center">Set New Password</h1>
        <p className="text-sm text-slate-400 text-center mb-6">Choose a strong new password</p>
        {!token ? (
          <p className="text-center text-red-400 text-sm" data-testid="reset-invalid">
            Invalid reset link. Please request a new one from{" "}
            <Link to="/forgot-password" className="text-emerald-400 hover:underline">Forgot Password</Link>.
          </p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label className="text-slate-300">New Password</Label>
              <Input data-testid="reset-password-input" type="password" required value={pw}
                onChange={(e) => setPw(e.target.value)} className="mt-1.5 bg-white/5 border-slate-700"
                placeholder="••••••••" />
            </div>
            <div>
              <Label className="text-slate-300">Confirm Password</Label>
              <Input data-testid="reset-confirm-input" type="password" required value={cf}
                onChange={(e) => setCf(e.target.value)} className="mt-1.5 bg-white/5 border-slate-700"
                placeholder="••••••••" />
            </div>
            <Button data-testid="reset-submit-btn" type="submit" disabled={loading}
              className="w-full rounded-full bg-emerald-500 hover:bg-emerald-600 text-white h-11">
              {loading ? "Resetting…" : "Reset Password"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
